function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}
export var ModalMagnificService = /*#__PURE__*/function () {ModalMagnificService.$inject = ["$timeout", "$q"];

  function ModalMagnificService($timeout, $q) {
    "ngInject";_classCallCheck(this, ModalMagnificService);
    this.$timeout = $timeout;
    this.$q = $q;
  }_createClass(ModalMagnificService, [{ key: "onDefinedElement", value: function onDefinedElement(

    ev) {var _this = this;
      var elem = null;
      var clone = null;
      var append = null;

      elem = angular.element(ev.target).parent();
      clone = elem.clone();
      append = angular.element('.ui-magnific-modal__append');

      append.html();
      this.$q.resolve().
      then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 10);});}).
      then(function () {
        angular.element('.ui-magnific-modal__append').append(clone).css({
          position: 'absolute',
          left: elem.offset().left,
          top: elem.offset().top,
          width: elem.width(),
          height: elem.height() });

      }).
      then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 100);});}).
      then(function () {
        var innerContainer = angular.element('.ui-magnific-modal__inner');
        var element = angular.element('.ui-magnific-modal__append');
        angular.element('.ui-magnific-modal__append').css({
          left: innerContainer.offset().left + innerContainer.width() / 2 - element.width() / 2,
          top: innerContainer.offset().top + innerContainer.height() / 2 - element.height() / 2 });

      }).
      then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 400);});}).
      then(function () {
        var innerContainer = angular.element('.ui-magnific-modal__inner');
        angular.element('.ui-magnific-modal__append').css({
          left: innerContainer.offset().left,
          top: innerContainer.offset().top,
          width: innerContainer.width(),
          height: innerContainer.height() });

      }).
      then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 600);});}).
      then(function () {
        var innerContainer = angular.element('.ui-magnific-modal__inner');
        angular.element('.ui-magnific-modal').addClass('is-show');
      });
    } }]);return ModalMagnificService;}();